<template>
  <el-dialog append-to-body title="添加箱子" :visible.sync="dialogVisible" width="30%">
    <div>
      <div>
        <span class="label__span">选择模板：</span>
        <el-select v-model="boxCode" placeholder="请选择" @change="selectBoxTemplate">
          <el-option v-for="item in boxTemplates" :key="item.boxTemplateId" :label="item.templateName"
            :value="item.boxTemplateId">
          </el-option>
        </el-select>
      </div>
      <ul class="boxSize__ul">
        <li class="boxSize__li">
          <span class="label__span">长：</span>
          <el-input maxlength='450' :disabled="boxDisabled" v-model="boxSizeInfo.length" placeholder="箱子长">
            <template slot="append">cm</template>
          </el-input>
        </li>
        <li class="boxSize__li">
          <span class="label__span">宽：</span>
          <el-input maxlength='450' :disabled="boxDisabled" v-model="boxSizeInfo.width" placeholder="箱子宽">
            <template slot="append">cm</template>
          </el-input>
        </li>
        <li class="boxSize__li">
          <span class="label__span">高：</span>
          <el-input maxlength='450' :disabled="boxDisabled" v-model="boxSizeInfo.height" placeholder="箱子高">
            <template slot="append">cm</template>
          </el-input>
        </li>
      </ul>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="containerAddBoxConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { setContainerBoxInfo, getBox } from "@/apis/outStock";

export default {
  name: "AddContainerDialog",
  props: {
    boxTemplates: {
      type: Array,
      default: (_) => [],
    },
  },
  data() {
    return {
      containerInfo: null,
      dialogVisible: false,
      boxSizeInfo: {
        width: 0,
        height: 0,
        length: 0
      },
      boxCode: '',
      boxDisabled: true,
    }
  },
  mounted() {

  },
  methods: {
    open: function (c) {
      this.dialogVisible = true
      this.containerInfo = c
      // this.boxTemplates = c.boxTemplates
    },
    restHandle: function () {
      this.boxSizeInfo = {
        width: 0,
        height: 0,
        length: 0
      }
      this.boxCode = ''
    },
    // 容器确定添加箱子
    containerAddBoxConfirm: function () {
      if (!this.boxCode) {
        this.$message.warning('请添加箱子')

        return;
      }
      const that = this
      const { insidePackCode, deliveryTaskCode } = that.containerInfo
      const { width, height, length } = that.boxSizeInfo
      const params = {
        deliveryTaskCode,
        insidePackCode,
        length,
        height,
        width,
        boxTemplateId: this.boxCode
      }
      setContainerBoxInfo(params).then(({ code, data = [] }) => {
        if (code === 0) {
          that.dialogVisible = false
          that.$message.success('新增成功')
          that.$bus.$emit('triggerRefreshFBA')
          that.restHandle()
        } else {
          that.$message.success('失败')
        }
      })
    },
    // 选中箱子模板
    selectBoxTemplate: function (val) {
      const that = this
      console.log(val)
      // 当选中固定模板时
      if (!!val && val !== '') {
        that.boxDisabled = true
        that.boxTemplates.forEach(item => {
          if (item.boxTemplateId === val) {
            const { width, length, height } = item
            that.boxSizeInfo = {
              width,
              length,
              height
            }
          }
        })
      } else {
        that.boxDisabled = false
      }
    },
  }
}
</script>

<style scoped>
.boxSize__ul {
  margin: 20px 0;
}

.label__span {
  display: inline-block;
  width: 100px;
}

.boxSize__li {
  margin: 8px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.boxSize__li ::v-deep.el-input {
  width: 250px;
}
</style>